"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { LANGUAGE_LABELS, LANGUAGE_SHORT_LABELS } from "@/shared/config/i18n/config";
import { useLanguage } from "@/shared/hooks/use-language";
export function LandingLanguageSwitcher() {
  const $ = _c(17);
  const {
    language,
    languages,
    setLanguage
  } = useLanguage();
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] !== open) {
    t0 = () => setOpen(!open);
    $[0] = open;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Globe className="size-3.5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = LANGUAGE_SHORT_LABELS[language];
  let t3;
  if ($[3] !== t2) {
    t3 = <span>{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronDown className="size-3" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t0 || $[7] !== t3) {
    t5 = <button onClick={t0} className="flex cursor-pointer items-center gap-1.5 rounded-lg px-3 py-2 text-sm text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900">{t1}{t3}{t4}</button>;
    $[6] = t0;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== language || $[10] !== languages || $[11] !== open || $[12] !== setLanguage) {
    t6 = open ? <><div className="fixed inset-0 z-10" onClick={() => setOpen(false)} /><div className="absolute right-0 z-20 mt-1 min-w-36 overflow-hidden rounded-xl border border-slate-200 bg-white py-1 shadow-lg">{languages.map(lang => <button key={lang} onClick={() => {
          setLanguage(lang);
          setOpen(false);
        }} className={`flex w-full items-center px-3.5 py-2 text-left text-sm transition-colors ${lang === language ? "bg-teal-50 font-medium text-teal-700" : "text-slate-600 hover:bg-slate-50"}`}>{LANGUAGE_LABELS[lang]}</button>)}</div></> : null;
    $[9] = language;
    $[10] = languages;
    $[11] = open;
    $[12] = setLanguage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="relative">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}